import React from "react";
import { Link } from "react-router-dom";
import { useIntl, FormattedMessage, defineMessages } from "react-intl";

import Profile from "../header/headerActions/profile";
import MainHeader from "../header/mainHeader";

const messages = defineMessages({
    routesNotFoundPageTitle: {
        id: "routes-not-found.title",
        defaultMessage: "CMIS",
        description: "Not found error page main header title",
    },
});

const NotFound = () => {
    const intl = useIntl();

    return (
        <>
            <MainHeader subtitle={intl.formatMessage(messages.routesNotFoundPageTitle)} actions={[<Profile />]} />
            <div>
                <h1>
                    <FormattedMessage
                        id="routes-not-found.error-message"
                        defaultMessage="404 - Not Found!"
                        description="Basic error message when 404 occurs"
                    />
                </h1>
                <Link to="/">
                    <FormattedMessage id="routes-not-found.home-button" defaultMessage="Go Home" description="Return back to main page button" />
                </Link>
            </div>
        </>
    );
};

export default NotFound;
